"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderElement = void 0;

var renderElement = function renderElement(_ref) {
  var variant = _ref.variant,
      appearance = _ref.appearance;

  if (appearance === 'bold') {
    return 'strong';
  }

  if (appearance === 'italic') {
    return 'em';
  }

  switch (variant) {
    case 'code':
    case 'small':
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return variant;

    case 'caption':
      return 'small';

    case 'article':
    case 'body':
      return 'p';

    case 'span':
    default:
      return 'span';
  }
};

exports.renderElement = renderElement;